import { render, staticRenderFns } from "./change-pwd.vue?vue&type=template&id=3409f9a3&scoped=true&"
import script from "./change-pwd.vue?vue&type=script&lang=js&"
export * from "./change-pwd.vue?vue&type=script&lang=js&"
import style0 from "./change-pwd.vue?vue&type=style&index=0&id=3409f9a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409f9a3",
  null
  
)

export default component.exports